import { useCallback, useRef } from "react";
import { DataContext, DataState, useDataContext } from "../core/hooks/useData";
import { Modal, ModalSize } from "../core/ui/Modal";
import { InlinePresenter } from "./InlinePresenter";
import { newID } from "../core/utils/unique";
import { getPresenter } from "./Presenter";
import { Map, MapPropTypes, transform } from "../core/utils/map";
import { ContainerElement, Element, GroupElement } from "./types";
import { useSaveAwareness } from "../core/hooks/useSaveContext";


export function FormModal(props: {
	title?: string,
	
	form: string,
	obj?: any,
	options?: any,

	size?: ModalSize,

	// map to apply when populating values from form back to result on save
	map?: Map,

	children?: any,

	onCancel: () => void,
	onSave: (value: any, data: DataState<any>) => void,
}) {

	const presenterID = useRef("");
	if (!presenterID.current) presenterID.current = newID();

	const data = useDataContext({
		initialValue: {},
		// validators: [
		// 	{
		// 		validate: (context) => {
		// 			const presenter = getPresenter(presenterID.current);
		// 			if (presenter) {
		// 				debugger;
		// 				if (!presenter.validateAll()) {
		// 					context.errors.push({
		// 						message: "Form incomplete"
		// 					})
		// 				}
		// 			}
		// 		}
		// 	}
		// ]
	});
	// have to trigger first validate to activate the save button on modal
	if (data.validateCount === 0) data.validate();

	const obj = props.obj ? props.obj : {};

	return (
		<DataContext.Provider value={data}>
			<Modal
				title={props.title}
				editableTitle={!props.title ? {
					obj: obj,
					prop: "title",
				} : undefined}
				editableSubtitle={!props.title ? {
					obj: obj,
					prop: "id",
				} : undefined}

				size={props.size ? props.size : "width-50vw"}
				onSave={() => {
					if (prepareFormDataForSave(
						presenterID.current,
						obj,
						props.map,
					)) {
						// do save
						props.onSave(obj, data);
					}
				}}
				onCancel={props.onCancel}
			>
				<InlinePresenter
					formID={props.form}
					id={presenterID.current}
					sourceValuesFrom={obj}
					options={props.options}
				/>

				{props.children}
			</Modal>
		</DataContext.Provider>
	);
}

export function FormInline(props: {	
	form: string,
	obj?: any,
	options?: any,

	children?: any,

	// map to apply when populating values from form back to result on save
	map?: Map,
}) {

	const data = useDataContext({
		initialValue: {},
	});

	const presenterID = useRef("");
	if (!presenterID.current) presenterID.current = newID();

	const obj = props.obj ? props.obj : {};
	
	useSaveAwareness(useCallback(() => {
		const ok = prepareFormDataForSave(
			presenterID.current, 
			props.obj,
			props.map,
		);
		return ok;
	}, []));
	
	return (
		<DataContext.Provider value={data}>

			<InlinePresenter
				formID={props.form}
				id={presenterID.current}
				sourceValuesFrom={obj}
				options={props.options}
			/>

			{props.children}

		</DataContext.Provider>
	);
}

export function prepareFormDataForSave(presenterID: string, objUpdating?: any, map?: Map) {
	// validate before attempting to save
	const presenter = getPresenter(presenterID);
	const ok = presenter.validateAll();
	if (!ok) return false;

	// if no specific map provided then auto generate from the form definition
	let mapToUse = map ? map : createFormDefMap(presenter.rootContainer.def);

	//const value: any = {};
	// NOTE: transform the data back into the original value so any props not associated with form are retained
	transform(mapToUse, presenter.root.value, objUpdating);

	return true;
}


function createFormDefMap(root: ContainerElement) {

	function parseElement(el: Element, map: Map) {

		let srcType: MapPropTypes = "simple";
		let src = el.id;
		let mapForThisProp;

		if (el.type === "container") {
			const container = el as ContainerElement

			if (container.repeat) {
				// list
				srcType = "list";			
			}

			// containers need their own map
			mapForThisProp = {
				props: [],
			};
			for(let child of container.elements) {
				parseElement(child, mapForThisProp);
			}
		}

		if (el.type === "group") {
			const group = el as GroupElement;
			for(let child of group.elements) {
				parseElement(child, map);
			}
		}

		map.props.push({
			srcType, 
			src,
			map: mapForThisProp,
		});
	
	}

	const map: Map = {
		props: [],
	};

	for(let child of root.elements) {
		parseElement(child, map);
	}

	return map;

}






